import React from 'react';
import { Jumbotron } from 'reactstrap';


function Header(props){
    return(
        <>
            <Jumbotron className="mb-2">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2>{props.destination}</h2>
                        </div>
                    </div>
                </div>
            </Jumbotron>
        </>
    );
}

export default Header;